import {ValidatorDNSInput} from "../../definitions/utils/validator/validatorDNS/ValidatorDNSInput";
import {ValidatorDNSTypes} from "../../definitions/utils/validator/validatorDNS/ValidatorDNSTypes";
import {DOM} from "../DOM";
import {DnsTypes} from "../../definitions/utils/validator/validator/DnsTypes";
import {StringValidator} from "./StringValidator";
import {StringValidatorValidationType} from "../../definitions/utils/validator/stringValidator/StringValidatorValidationType";
import {DnsValidationType} from "../../definitions/utils/validator/validator/DnsValidationType";

/**
 * Contains DNS specific validations
 */
export class ValidatorDNS {

    public static validate(string: string, input: ValidatorDNSInput, params: DnsValidationType, element: HTMLInputElement | HTMLTextAreaElement, form: HTMLFormElement, isUpdate: boolean|null) : boolean {
        switch (input.name) {
            case ValidatorDNSTypes.IPV4: return StringValidator.validateString(string, {name: StringValidatorValidationType.IPV4, meta: input.meta});
            case ValidatorDNSTypes.IPV6: return this.validateIPV6(string);
            case ValidatorDNSTypes.STRING2_DOMAIN_NAME_OPT_DOT: return this.validateString2DomainNameOptDot(string);
            case ValidatorDNSTypes.STRING2_DOMAIN_NAME_MX: return this.validateString2DomainNameMX(string);
            case ValidatorDNSTypes.STRING2_DNAME: return this.validateString2DNAME(string);
            case ValidatorDNSTypes.STRING2_CNAME: return this.validateString2CNAME(string);
            case ValidatorDNSTypes.STRING1_CNAME_A_SAME_VALIDATION: return this.validateString1CnameASameValidation(string, params, element, form, isUpdate);
            case ValidatorDNSTypes.STRING2_TXT: return this.validateString2TXT(string);
            case ValidatorDNSTypes.STRING2_SRV: return this.validateString2SRV(string);
            case ValidatorDNSTypes.STRING1: return this.validateString1(string);
            case ValidatorDNSTypes.STRING1_NOT_AT: return this.validateString1NotAt(string);
            case ValidatorDNSTypes.NUMERIC: return StringValidator.validateString(string, {name: StringValidatorValidationType.NUMERIC, meta: input.meta});
            case ValidatorDNSTypes.REQUIRED: return StringValidator.validateString(string, {name: StringValidatorValidationType.REQUIRED, meta: input.meta});
            default: throw Error('Wrong extend validation name: ' + input.name);
        }
    }

    /**
     * Validate same STRING1 in A and CNAME problem
     * @param currentValue
     * @param element - validated input element or textarea
     * @param params - arguments
     * @param form
     * @param isUpdate
     */
    private static validateString1CnameASameValidation(currentValue: string, params: DnsValidationType, element: HTMLInputElement | HTMLTextAreaElement, form: HTMLFormElement, isUpdate: boolean|null): boolean {

        const currentDnsTypeSelect = DOM.Parser.getHtmlInputElementByName(params.typeInputName) as HTMLSelectElement;
        const currentDnsType = currentDnsTypeSelect.value as DnsTypes;
        const currentIndex: number = parseInt(element.name.split('_')[0])

        const string1InputElements = DOM.Parser.getHtmlElements('dns-domain-row-string1Input', form, true) as HTMLCollectionOf<HTMLInputElement>;
        for (let i = 0; i < string1InputElements.length; i++) {

            // Get looped row index, if same as current continue
            const string1InputElement = string1InputElements[i];
            const string1OrderIndex = parseInt(string1InputElement.name.split('_')[0]);
            if (currentIndex === string1OrderIndex) { continue; }
            if (!isUpdate && (currentDnsType === DnsTypes.A || currentDnsType === DnsTypes.CNAME)) {
                string1InputElement.dispatchEvent(new Event("update"));
            }

            // Get looped row data
            const string1TypeSelect = DOM.Parser.getHtmlInputElementByName(`${string1OrderIndex}_type`) as HTMLSelectElement;
            const string1Type = string1TypeSelect.value as DnsTypes;
            const string1Value = string1InputElement.value.trim();

            // Find problem
            if ((currentDnsType === DnsTypes.A && string1Type === DnsTypes.CNAME) || (currentDnsType === DnsTypes.CNAME && string1Type === DnsTypes.A)) {
                if (currentValue === string1Value) {
                   return false;
                }
            }
        }

        return true;
    }

    private static validateIPV6(string: string) : boolean {
        return (/^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:)(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/.test(string));
    }

    private static validateString2DomainNameOptDot(string: string) : boolean {
        return /^\b((?=[a-z0-9-]{1,63}\.)(xn--)?[a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,63}\b\.?$/.test(string);
    }

    private static validateString2DomainNameMX(string: string) : boolean {

        return string.endsWith(".")
            ? /^\b((?=[A-Za-z0-9-]{1,63}\.)(xn--)?[A-Za-z0-9]+(-[A-Za-z0-9]+)*\.)+[A-Za-z]{2,63}\b\.?$/.test(string)
            : string.length > 0;
    }

    private static validateString2CNAME(string: string) : boolean {

        const anyCharacterFound : boolean = /[a-zA-Z]/.test(string);
        const correctFormat : boolean = /^[a-zA-Z0-9_][a-zA-Z0-9_\-.]*[a-zA-Z0-9_.]$|^[a-zA-Z0-9]$/.test(string);
        return anyCharacterFound && correctFormat;
    }

    private static validateString2DNAME(string: string) : boolean {

        const anyCharacterFound : boolean = /[a-zA-Z]/.test(string);
        const correctFormat : boolean = /^[a-zA-Z0-9_][a-zA-Z0-9_\-.]*[a-zA-Z0-9_.]$|^[a-zA-Z0-9]$/.test(string);
        return anyCharacterFound && correctFormat;
    }

    private static validateString2TXT(string: string) : boolean {
        return !/"/.test(string.toString()) && string.length <= 1024;
    }

    private static validateString2SRV(string: string) : boolean {

        const fragments = string.split(" ")
        return fragments.length === 3 && /^[0-9]+$/.test(fragments[0])
            && /^[0-9]+$/.test(fragments[1])
            && /^\b((?=[A-Za-z0-9-]{1,63}\.)(xn--)?[A-Za-z0-9]+(-[A-Za-z0-9]+)*\.)+[A-Za-z]{2,63}\b\.$/.test(fragments[2]);
    }

    private static validateString1(string: string) : boolean {

        if (string === '@' || string === "." || string === "*") return true;
        if (string.length > 63) return false;
        const anyCharacterFound : boolean = /[a-zA-Z]/.test(string);
        const correctFormat : boolean = /^[a-zA-Z0-9_*][a-zA-Z0-9_\-.]*[a-zA-Z0-9_.]$|^[a-zA-Z0-9]$/.test(string);
        return anyCharacterFound && correctFormat;
    }

    private static validateString1NotAt(string: string) : boolean {
        return string !== "@";
    }
}


